import React, { Component } from 'react';

class MasterLinkInfoTooltip extends Component {
  render() {
    return (
      <div className="short-code-info-tooltip">
        To customize your <b>shorten link</b> you simply need to add your unique{' '}
        <b>nickname</b> which identifies you. It’s always better to use
        something simple, but be sure this link is not occupied by other users.
        Please note that short codes can only contain letters and numbers (no
        spaces or special characters).
        <br />
        <br />
        The blue button with the small cute arrow to the left of <b>
          ? button
        </b>{' '}
        will allow you to preview your personalized page in a separate browser
        tab. The little grey button with 2 squares will allow you to copy the
        whole your link together with personalized nickname to the clipboard.
        Also, you can send it to everyone or adding to your social Channel like
        Instagram, Facebook or your email footer.
        <br />
        <br />
        Enjoy using your awesome new social enhancer!
      </div>
    );
  }
}

export default MasterLinkInfoTooltip;



// WEBPACK FOOTER //
// ./src/components/MasterLinkInfoTooltip/MasterLinkInfoTooltip.js